<section class="flex flex-col gap-4 p-6">
  <p class="text-paragraph-med text-primary-900">
    {{ "prestation.customFactor" | transloco }}
  </p>

  <app-category-selector
    [categoryList]="items"
    [(selectedValue)]="value"
    type="scroll"
  />
</section>
